import React from 'react';
import { WebsiteLayout } from '../components/common/layout';
import { Terms } from '../components/screens';

function PageWithLayout(props) {
  const { logout, user } = props;

  return (
    <WebsiteLayout navbarBackgroundColor="white" user={user} handleLogout={logout}>
      <Terms />
    </WebsiteLayout>
  );
}

export default PageWithLayout;
